import { GetterTree } from 'vuex';
import { NotificationState } from './types/notification.types';
import { RootState } from '@/store/store';

export const notificationGetters: GetterTree<NotificationState, RootState> = {};
